import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Image } from "hesus-ui-kit";
import dotIcon from "@icons/ic-dot-navy-blue.svg";
import DocumentPreview from "../../../../Document/DocumentPreview/DocumentPreview";
import { getDateFormat } from "@utils/datePickerUtils";
import {
  AcceptanceOuter,
  GridRow,
  GridSubItem,
  DocumentRow,
  DocumentName,
} from "../../SolutionAcceptanceView.styled";
import "../../SolutionAcceptanceView.scss";

const AcceptanceContent = (props) => {
  const { t, data } = props;
  const [selectedDocument, setSelectedDocument] = useState(null);

  const openPreview = (document) => setSelectedDocument(document);
  const closePreview = () => setSelectedDocument(null);

  return (
    <>
      <AcceptanceOuter marginBottom="10px">
        <GridRow
          column="auto 1fr"
          marginBottom="0px"
          marginTop="0px"
          padding="5px 10px 0px 10px"
          gridGap=".25rem"
        >
          <GridSubItem
            fontWeight="700"
            fontSize="16px"
            color={data?.isActive ? "#0A4986" : "#767676"}
          >
            {t("SOLUTION_ACCEPTANCE_CAPACITY")} :
          </GridSubItem>
          <GridSubItem
            fontWeight="400"
            fontSize="16px"
            color={data?.isActive ? "#474747" : "#767676"}
          >
            {data.capacityQuantity
              ? data.capacityQuantity
              : "" + " " + t(data.capacityUnit)}
          </GridSubItem>
        </GridRow>
        <GridRow
          column="auto 1fr"
          marginBottom="0px"
          marginTop="0px"
          padding="0px 10px"
          gridGap=".25rem"
        >
          <GridSubItem
            fontWeight="700"
            fontSize="16px"
            color={data?.isActive ? "#0A4986" : "#767676"}
          >
            {t("SOLUTION_ACCEPTANCE_VALIDITY")} :
          </GridSubItem>
          <GridSubItem
            fontWeight="400"
            fontSize="16px"
            color={data?.isActive ? "#474747" : "#767676"}
          >
            {/* {data.validityStart + " - " + data.validityEnd} */}
            {getDateFormat(data.validityStart, "YYYY-MM-DD")} -{" "}
            {getDateFormat(data.validityEnd, "YYYY-MM-DD")}
          </GridSubItem>
        </GridRow>
        <GridRow
          column="1fr"
          marginBottom="0px"
          marginTop="0px"
          padding="0px 10px"
          gridGap=".25rem"
        >
          <GridSubItem
            fontWeight="700"
            fontSize="16px"
            color={data?.isActive ? "#0A4986" : "#767676"}
          >
            {t("SOLUTION_ACCEPTANCE_COMMENT")} :
          </GridSubItem>
        </GridRow>
        <GridRow
          column="1fr"
          marginBottom="0px"
          marginTop="0px"
          padding="0px 10px"
          gridGap=".25rem"
        >
          <GridSubItem
            fontWeight="400"
            fontSize="16px"
            color={data?.isActive ? "#474747" : "#767676"}
          >
            {data.comment ? data.comment : "-"}
            {data?.documents?.length !== "" &&
              data?.documents?.map((document, documentIndex) => {
                return (
                  <DocumentRow
                    key={`solution-acceptance-view-${data.id}${document.id}${documentIndex}`}
                  >
                    <GridRow gap="0rem" column="1fr auto">
                      <DocumentName
                        onClick={() => openPreview(document)}
                        className={
                          data?.isActive
                            ? "solution-acceptance-view__document-link"
                            : "solution-acceptance-view__document-link-grey"
                        }
                      >
                        <Image
                          className="deleteImage"
                          src={dotIcon}
                          alt="delete"
                          styles={{ marginRight: "6px" }}
                        />
                        {document?.fileName}
                      </DocumentName>
                    </GridRow>
                  </DocumentRow>
                );
              })}
          </GridSubItem>
        </GridRow>
      </AcceptanceOuter>
      {selectedDocument && (
        <DocumentPreview document={selectedDocument} onClose={closePreview} />
      )}
    </>
  );
};

AcceptanceContent.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(AcceptanceContent);
